export default "__VITE_ASSET__DSVlSSx3__"